<style>

.upload-pic{
  margin: auto;
  width: 300px;
  height: 300px;
  background-image: url('/i/alison-james.jpg');
  background-color: gray;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
}

.body{
  margin: 30px auto;
  width: 300px;
}
.margin{
  margin: 30px auto 0 auto;
  width: 300px;
}
.photos{
  display: flex;
  justify-content: center;
}

.a-photo{
  width: 100px;
  height: 100px;
  background-image: url('/i/alison-james-pic01.jpg');
  background-color: gray;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  margin: 5px;
}
.label{
  color: gray;
}
.label-input{
  margin: 10px 10px 1px 10px;
}
input[type="text"], input[type="password"]{
  border-radius: 5px;
}
textarea{
  min-height: 300px;
  border-radius: 5px;
}
.chars-left{
  font-size: 16px;
  margin: 0 10px 0 10px;
}

</style>

<Dialog show="{editMyInfo}" title="Edit My Info" close="{false}" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, } ] }" on:done="{editMyInfoDone}" on:close="{ () => editMyInfo = false }">
  <div class="label-input">Name</div>
  <div><input type="text" bind:value="{tname}"></div>
  
  <div class="label-input">Phone</div>
  <div><input type="text" bind:value="{tphone}"></div>
  
  <div class="label-input">Email</div>
  <div><input type="text" bind:value="{temail}"></div>
</Dialog>

<Dialog show="{editMyBio}" title="Edit My Bio" close="{false}" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, } ] }" on:done="{editMyBioDone}" on:close="{ () => editMyBio = false }">
  <div class="label-input">Bio</div>
  <div> <textarea bind:value="{tbio}" on:keyup="{bioChange}"></textarea> </div>
  <div class="chars-left">{tbioLen} Characters Left</div>
</Dialog>

<Dialog show="{editMyPassword}" title="Change My Password" close="{false}" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, } ] }" on:done="{editMyPasswordDone}" on:close="{ () => editMyPassword = false }">
  <div class="label-input">Password</div>
  <div><input type="password" bind:value="{tpassword}"></div>
  <div class="chars-left">{passwordMessage}</div>
</Dialog>


<Dialog show="{logoutCheck}" title="Logout?" close="{false}" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Yes', callback: 'done', disabled: false, } ] }" on:done="{logout}" on:close="{ () => logoutCheck = false }">
</Dialog>

<Header 
back="{true}"
buttons="{ [ {icon: 'icon-calendar_add', text: 'Add Event', callback: 'addEvent', disabled: false, }] }"
on:addEvent="{ () => push('/create-new-event') }"
on:back="{ () => { pop() } }">Edit Profile</Header>
<div class="has-header"></div>

<ImageEdit show="{showImageEdit}" on:close="{ () => {showImageEdit = false} }"></ImageEdit>

<div class="upload-pic" on:click="{ () => {showImageEdit = true} }"></div>

<div class="body" on:click="{editMyInfoNow}">
  <div class="label">+ MY INFO</div>
  <div>{name}</div>
  <div>{phone}</div>
  <div>{email}</div>
</div>

<div class="body" on:click="{editMyBioNow}">
  <div class="label">+ MY BIO</div>
  <div>{bio}</div>
</div>

<div class="margin label">
  + ADD PHOTOS
</div>
<div class="photos">
  <div class="a-photo"></div>
  <div class="a-photo"></div>
  <div class="a-photo"></div>
</div>

<div class="body" on:click="{ () => push('/edit-interests') }">
  <div class="label">+ EDIT INTERESTS</div>
</div>

<div class="body" on:click="{ () => push('/edit-questions') }">
  <div class="label">+ EDIT QUESTIONS</div>
</div>

<div class="body">
  <div class="label">+ FIND EVENTS</div>
</div>

<div class="body">
  <div class="label" on:click="{ () => push('/find-friends') }">+ FIND FRIENDS</div>
</div>

<div class="body" on:click="{editMyPasswordNow}">
  <div class="label">+ CHANGE PASSWORD</div>
</div>

<!-- <div class="body" on:click="{logoutCheck}"> -->
<div class="body" on:click="{ () => logoutCheck = true }">
  <div class="label">LOGOUT</div>
</div>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Header from "../components/Header.svelte";
import ImageEdit from "../components/ImageEdit.svelte";
import Dialog from "../components/Dialog.svelte";


let username = "@alison93";
let name = "Alison James";
let phone = "805-555-5555";
let email = "alij83@example.com";
let birthday = "02/21/1983";
let password = "Alison James";
let bio = "I absolutely love grass.  The green kind.  My favorite grass is the kind you can lay on.";

let tname = "Alison James";
let tphone = "805-555-5555";
let temail = "alij83@example.com";
let tbio = "I absolutely love grass.  The green kind.  My favorite grass is the kind you can lay on.";
let tbioLen = 1000 - tbio.length;
let tpassword = "";
let passwordMessage = "";

let businessUsername = "@TheGrove";
let businessName = "The Grove Nighclub";
let businessPhone = "805-555-5555";
let businessEmail = "contact@thegrove.com";
let businessCategory = "Night Club";
let businessPassword = "TheGrove!"

let showImageEdit = false;
let editMyInfo = false;
let editMyBio = false;
let editMyPassword = false;


function editMyInfoNow() {
  tname = name;
  tphone = phone;
  temail = email;
  editMyInfo = true;
}


function editMyInfoDone() {
  name = tname;
  phone = tphone;
  email = temail;
  editMyInfo = false;
}


function editMyBioNow() {
  tbio = bio;
  tbioLen = 1000 - tbio.length;
  editMyBio = true;
}


function editMyBioDone() {
  bio = tbio;
  editMyBio = false;
}


function bioChange(e) {
  tbioLen = 1000 - tbio.length;
}


function editMyPasswordNow() {
  editMyPassword = true;
}


function editMyPasswordDone() {
  editMyPassword = false;
}


function passwordChange(e) {
}

function logoutCheck() {
  logoutCheck = true;
}

function logout() {
}

</script>